import { render, staticRenderFns } from "./academy_dashboard.vue?vue&type=template&id=153e82e0&scoped=true"
import script from "./academy_dashboard.vue?vue&type=script&lang=js"
export * from "./academy_dashboard.vue?vue&type=script&lang=js"
import style0 from "./academy_dashboard.vue?vue&type=style&index=0&id=153e82e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153e82e0",
  null
  
)

export default component.exports